import React from 'react';
import { Moon, Sun } from 'lucide-react';

const DarkModeToggle = ({ isDark, onToggle }) => {
  return (
    <button
      data-testid="dark-mode-toggle"
      onClick={onToggle}
      className="relative w-10 h-10 flex items-center justify-center rounded-full transition-colors duration-300 hover:scale-110"
      style={{
        background: isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
      }}
      aria-label="Toggle dark mode"
    >
      <Sun
        size={18}
        className="absolute transition-all duration-500"
        style={{
          opacity: isDark ? 0 : 1,
          transform: isDark ? 'rotate(90deg) scale(0)' : 'rotate(0) scale(1)',
          color: '#000',
        }}
      />
      <Moon
        size={18}
        className="absolute transition-all duration-500"
        style={{
          opacity: isDark ? 1 : 0,
          transform: isDark ? 'rotate(0) scale(1)' : 'rotate(-90deg) scale(0)',
          color: '#fff',
        }}
      />
    </button>
  );
};

export default DarkModeToggle;
